import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import KanbanPage from '@/pages/kanban/KanbanPage'
import PipelineConsultorPage from '@/pages/kanban/PipelineConsultorPage'

/**
 * Rotas do A10 (Onda 5) — Pipeline Comercial em dois níveis (decisão 6.4):
 * CONSULTOR vê as 6 etapas comerciais (`PipelineConsultorPage`); o back-office
 * (ADMIN/GERENTE/OPERADOR) segue na jornada completa de 18 status (`KanbanPage`).
 *
 * INTEGRAÇÃO (coordenador, no merge): o path `pipeline` hoje está registrado em
 * `rotas/a02.tsx` apontando direto para o KanbanPage (decisão do A02: página antiga
 * até a do Figma existir — que é esta). Conflito de path é do coordenador resolver
 * (comentário no `router/index.tsx`): trocar a linha do a02 por `...rotasA10` — ou
 * remover a linha lá e concatenar `...rotasA10` no `router/index.tsx` após rotasA02.
 */
const PipelinePorPersona: FC = () => {
  const usuario = authStore((s) => s.usuario)
  const ehBackoffice = !!usuario?.permissoes?.some((p) => {
    const up = p.toUpperCase()
    return up === 'ADMIN' || up === 'GERENTE' || up === 'OPERADOR'
  })
  return ehBackoffice ? <KanbanPage /> : <PipelineConsultorPage />
}

const rotasA10: RouteObject[] = [{ path: 'pipeline', element: <PipelinePorPersona /> }]

export default rotasA10
